import type { MouseEventHandler } from 'react';
import styled, { css } from 'styled-components';
import { Play } from '@elfsight/icons';
import { Icon } from '@elfsight/lib-icon';
import { Show } from '@elfsight/lib-utils';
import type { MediaImageProps } from '@elfsight/widget-media';
import { MediaImage } from '@elfsight/widget-media';
import { Loader } from '@elfsight/widget-ui';
import { themeColors } from '../../../../themes';

interface VideoDummyProps {
  src: string;
  mediaImageProps: MediaImageProps;
  mode: 'loading' | 'redirect';
  onClick?: MouseEventHandler<HTMLDivElement>;
}

export function VideoDummy({
  src,
  mediaImageProps,
  mode,
  onClick
}: VideoDummyProps) {
  return (
    <VideoDummyContainer onClick={onClick}>
      <MediaImage src={src} {...mediaImageProps} ratio={0.66} />
      <Show when={mode === 'redirect'}>
        <VideoIcon size={48} />
      </Show>

      <Show when={mode === 'loading'}>
        <VideoLoader color="white" />
      </Show>
    </VideoDummyContainer>
  );
}

const VideoDummyContainer = styled.div`
  position: relative;
  width: 100%;
  cursor: pointer;
`;

const floatingMixin = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const VideoIcon = styled(Icon).attrs({
  component: Play,
  fill: themeColors.whiteColor
})`
  ${floatingMixin};
`;

const VideoLoader = styled(Loader)`
  ${floatingMixin};
`;
